/**
 * Shared styles for table filters to maintain consistency
 */
export const FILTER_STYLES = {
  input: { fontSize: '12px' },
  dropdown: { fontSize: '12px' },
} as const
